export default __webpack_public_path__ + "static/media/email.19c88e07.svg";